<template>
  <div class="animated fadeIn settings">
    <b-row>
      <b-col lg="6" md="12">
        <b-card>
          <div slot="header">
            <strong>Tùy chọn tổng quan
            </strong>
          </div>
          <div>Đang xây dựng</div>

          <div slot="footer">
            <b-button type="button" size="sm" variant="success">Lưu thay đổi</b-button>
          </div>
        </b-card>
      </b-col>

    </b-row>

  </div>
</template>

<script>
import {isAuth, isSuperAdmin} from "@/utils/auth";

export default {
  name: 'forms',
  data() {
    return {
      selected: [], // Must be an array reference!
      show: true
    }
  },
  mounted() {
    if (!isAuth() || !isSuperAdmin()) {
      this.$router.push('/login')
    }
  },
  methods: {
    click() {
      // do nothing
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
